'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var languages = require('./languages.js');

/**
 * @method normalizeLang
 * @description function to normalize lang key as need.
 * @param {String} key The language key
 * @param {('iso-2'|'iso-3')} type type of normalisation
 * If `type` === iso-2 return the 2 sumbols language code
 * If `type` === iso-3 return the 3 sumbols language code
 * @return {String} The language key based on passed `type`
 */
function normalizeLang(key, type, customLanguages) {
    if (customLanguages === void 0) { customLanguages = null; }
    if (!key)
        return key;
    key = key.toLowerCase();
    /** small optimization */
    if ((key.length === 2 && type === 'iso-2') || (key.length === 3 && type === 'iso-3')) {
        return key;
    }
    var langItem = null;
    if (customLanguages) {
        for (var i = 0; i != customLanguages.length; i++) {
            if (customLanguages[i].iso2 === key || customLanguages[i].iso3 === key) {
                langItem = customLanguages[i];
                break;
            }
        }
    }
    else {
        for (var i = 0; i != languages.languages.length; i++) {
            if (languages.languages[i].iso2 === key || languages.languages[i].iso3 === key) {
                langItem = languages.languages[i];
                break;
            }
        }
    }
    if (langItem) {
        if (type === 'iso-2') {
            return langItem.iso2;
        }
        else if (type === 'iso-3') {
            return langItem.iso3;
        }
        else if (type === 'name') {
            return langItem.name;
        }
        else if (type === 'full') {
            return langItem;
        }
    }
    return key;
}

exports.normalizeLang = normalizeLang;
